function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 5.5,
  width: 3,
  height: 8,
  rx: 0.5,
  stroke: "currentColor"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.796 12.754c-.28.317-.732.536-1.352.652-.616.114-1.348.118-2.122.048-1.375-.124-2.808-.47-3.822-.748V6.66a4.49 4.49 0 01.592-.6c.095-.084.199-.173.31-.267.218-.187.46-.393.69-.61.725-.68 1.472-1.576 1.888-2.988.1-.342.28-.528.476-.632.207-.11.471-.146.75-.106.281.039.54.15.716.286.185.143.22.261.22.31 0 .222-.041.558-.102.975l-.045.303c-.048.322-.1.665-.136.987-.048.418-.08.854-.035 1.199.021.168.067.371.182.544.133.201.353.346.635.346.23 0 .523-.035.806-.072l.198-.027c.233-.031.469-.063.7-.086.299-.03.558-.042.756-.023.164.015.222.045.232.049a.77.77 0 01.097.258c.039.167.063.387.069.654.01.534-.056 1.204-.194 1.914-.281 1.442-.833 2.914-1.509 3.68z",
  stroke: "#A0AFBE"
});
function SvgThumbupGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgThumbupGray;